// import Rules from './Rules';

export default {
  priority: 100,
  path: 'rules',
  permissions: ['StackRulesMenu'],
  // component: Rules,
  component: load(() => import(/* webpackChunkName: "Stack-Rules" */ './Rules')),
  name: app.translate('routes.home.attendance.stack.Rules'),
  icon: 'gavel',
  drawer: false,
};


